export type RegistrationCampaign = {
	campaignId?: string;
	recipientId?: string;
	capturedAt: string;
};

const CAMPAIGN_KEY = "registration_campaign";
const SESSION_ID_KEY = "registration_session_id";

const CAMPAIGN_ID_PARAM = "campaignId";
const RECIPIENT_ID_PARAM = "recipientId";

export function captureRegistrationCampaign(
	search: string = window.location.search
): void {
	const params = new URLSearchParams(search);

	const campaignId = readParam(params, CAMPAIGN_ID_PARAM);
	const recipientId = readParam(params, RECIPIENT_ID_PARAM);

	if (!campaignId && !recipientId) {
		return;
	}

	const campaign: RegistrationCampaign = {
		capturedAt: new Date().toISOString(),
	};

	if (campaignId) {
		campaign.campaignId = campaignId;
	}

	if (recipientId) {
		campaign.recipientId = recipientId;
	}

	writeItem(CAMPAIGN_KEY, JSON.stringify(campaign));
}

export function getRegistrationCampaign(): RegistrationCampaign | null {
	const rawCampaign = readItem(CAMPAIGN_KEY);

	if (!rawCampaign) {
		return null;
	}

	try {
		const campaign = JSON.parse(rawCampaign) as RegistrationCampaign;

		return campaign?.campaignId || campaign?.recipientId ? campaign : null;
	} catch {
		return null;
	}
}

export function startRegistrationSession(): string {
	const existingSessionId = readItem(SESSION_ID_KEY);

	if (existingSessionId) {
		return existingSessionId;
	}

	const sessionId = generateSessionId();

	writeItem(SESSION_ID_KEY, sessionId);

	return sessionId;
}

export function getRegistrationSessionId(): string | null {
	return readItem(SESSION_ID_KEY);
}

function readParam(params: URLSearchParams, name: string): string | undefined {
	return params.get(name)?.trim() || undefined;
}

function generateSessionId(): string {
	const bytes = crypto.getRandomValues(new Uint8Array(16));
	bytes[6] = (bytes[6] & 0x0f) | 0x40;
	bytes[8] = (bytes[8] & 0x3f) | 0x80;
	const hex = [...bytes].map((b) => b.toString(16).padStart(2, "0")).join("");

	return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`;
}

function readItem(key: string): string | null {
	try {
		return sessionStorage.getItem(key);
	} catch {
		return null;
	}
}

function writeItem(key: string, value: string): void {
	try {
		sessionStorage.setItem(key, value);
	} catch {}
}
